const partialVatRegistration = {
  subjectToVat: null,
};

const vatNotRegistered = {
  subjectToVat: false,
};

const VAT_ID_MAP = {
  AU: '12345678909',
  AT: 'ATU12345678',
  DE: 'DE123456789',
  FR: 'FRXX123456789',
  GB: 'GB123456789',
  NL: 'NL123456789B12',
  KI: '12345678909',
  IT: 'IT85494366301',
  PL: 'PL1231231232',
  PT: 'PT123123123',
  OTHER: 'CH854943663B01',
};

export function vatRegistrationStepConfig({ country }) {
  const vatRegistration = {
    subjectToVat: true,
    vatId: VAT_ID_MAP[country] || VAT_ID_MAP.OTHER,
  };

  return {
    vatId: {
      value: vatRegistration,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    vatNotRegistered: {
      value: vatNotRegistered,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialVatRegistration: {
      value: partialVatRegistration,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
  };
}
